import { Box } from '@material-ui/core';
import { HandHoldingPhone } from '@tink/core/src/components/atoms/Icons/HandHoldingPhone';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MarketCode } from '@tink/config/src/markets';
import { useRedirectPostMessage } from '../../../components/screens/AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/parent-redirect-messenger';
import { useConfiguration } from '../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { PrimaryButton } from '../../../components/atoms/Button/Button';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { Footer } from '../../../components/atoms/Footer/Footer';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { Stack } from '../../../components/atoms/Stack/Stack';
import { ApplicationUnverifiedLabel } from '../../../components/molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { Header as HeaderImport, HeaderProps } from '../../../components/organisms/Header/Header';
import { PageView } from '../../../models/analytics';
import { Provider, ProviderEntity } from '../../../models/provider';
import { messages } from '../../messages';
import { BackButton } from '../../../components/organisms/Header/HeaderMolecule';
import { usePageViewEvents } from '../../../core/Analytics/usePageViewEvents';
import { useUrlQuery } from '../../../components/ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { MxLabel } from '../../../components/screens/AwaitingCredentialsScreen/atoms/MxLabel/MxLabel';
import {
  IconContainer,
  ProviderLogo,
  ProviderLogoContainer,
} from './OpenThirdPartyRedirectScreen.styles';

export type OpenThirdPartyRedirectScreenProps = {
  isVerified: boolean;
  provider: ProviderEntity;
  redirectUrl: string | null;
  onButtonClick: () => void;
} & BackButton;

export type DependentComponents = {
  Header?: React.ComponentType<HeaderProps>;
};

export const OpenThirdPartyRedirectScreen: React.FC<
  OpenThirdPartyRedirectScreenProps & DependentComponents
> = ({ provider, isVerified, redirectUrl, onButtonClick, onBack, Header = HeaderImport }) => {
  const pageView = PageView.OPEN_THIRD_PARTY_REDIRECT_SCREEN;
  const { activeTheme } = useConfiguration();
  const { market } = useUrlQuery();
  const { primaryColor, backgroundColor, tintedBackgroundColor } = activeTheme.colors;
  const isMarketUS = market === MarketCode.US;
  usePageViewEvents({ pageView });
  useRedirectPostMessage({ redirectUrl });

  return (
    <ScreenWrapper>
      <Header onBack={onBack} pageView={pageView} />
      <ContentBody centerVertically centerHorizontally>
        {!isVerified && (
          <Box my="medium">
            <ApplicationUnverifiedLabel isVerified={false} />
          </Box>
        )}
        <Stack justifyContent="center" alignItems="center">
          <IconContainer>
            <HandHoldingPhone
              primaryColor={primaryColor}
              backgroundColor={backgroundColor}
              tintedBackgroundColor={tintedBackgroundColor}
            />
            <ProviderLogoContainer>
              <ProviderLogo src={Provider.getIcon(provider)} alt="" />
            </ProviderLogoContainer>
          </IconContainer>
          <H1 align="center">
            <FormattedMessage
              {...messages.logInToYourBankParametrized}
              values={{ providerName: provider.displayName }}
            />
          </H1>
        </Stack>
        <Footer stickToBottom>
          <PrimaryButton
            pageView={pageView}
            variant="contained"
            color="primary"
            onClick={onButtonClick}
          >
            <FormattedMessage {...messages.continue} />
          </PrimaryButton>
        </Footer>
        {isMarketUS && <MxLabel />}
      </ContentBody>
    </ScreenWrapper>
  );
};
